import basicSettingApi from '@/api/basicSetting/basicSettingApi'

const contractMap = {
	9: {
		contractName: '正常使用中',
		map:{
			25: {avaStatus: '掛失停話', value: 25, msg: '您確定要掛失停話? 一旦掛失，將需與客服聯絡方能復話，而無法使用線上復話'},
			27: {avaStatus: '掛失限話', value: 27, msg: '您確定要掛失限話? 一旦掛失，將需與客服聯絡方能復話，而無法使用線上復話'},
			29: {avaStatus: '自設限話', value: 29, msg: '您確定要自設限話嗎?'},
		}
	},
	29: {
		contractName:'自設限話',
		map:{ 9: {avaStatus: '自限復話', value: 9, msg: '您確定要自限復話嗎?'}},
	}
}

export default {
	name: 'use-change',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			contract: null,
			selectedContractStatus: null,
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			let contractStatus = await basicSettingApi.getContractStatus();
			// 若非限定的合約狀態，跳轉warn頁面
			this.contract = contractMap[contractStatus];
			if(!this.contract){
				this.$router.push({name: 'gt-warn', params: { msg: '很抱歉！您登入的身分不適用此功能。', title: '掛失/停話/復話', returnName: 'function-list' }})
				return;
			}
		},
		confirmContractStatusChange(){
			//驗證radio 表單
			if(!this.selectedContractStatus){
				$("#myModal").modal('show');
				return;
			}
			//再次確認表單
			$('#confirmModal').modal('show');
		},
		async submitForm(){
			let resp = await basicSettingApi.changeContractStatus(this.selectedContractStatus);
			if(resp.result == '0'){
				this.$router.push({name :'use-change-result'});
			}else{
				this.$router.push({name :'use-change-warning', params: {msg: resp.errMsg}});
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/useChange/useChange.js